<template>
  <main>
    <div style="background-color: white">
      <div class="service">
        <GradientAnimation />
        <div class="content">
          <div>
            <h1 :class="{ 'is-en': isEnglishLocale }" v-html="$t('home.heroTitle')"></h1>
            <h2 v-html="$t('home.heroBody')"></h2>
            <div class="action">
              <a class="button" :href="`${this.clientUrl}/auth/register`" target="_blank">
                <span>{{ $t('common.startNow') }}</span>
                <div class="arrowBox">
                  <span class="arrow">
                    <i /><i /><i />
                  </span>
                </div>
              </a>
              <router-link class="button" to="/customer" target="_blank">
                <span>{{ $t('common.contactUs') }}</span>
                <span class="arrow">
                  <i /><i /><i />
                </span>
              </router-link>
            </div>
          </div>

          <ClientAnimation />

        </div>
      </div>
      <div class="integration diagonal">
        <div class="content">
          <h3>{{ $t('home.integrationTitle') }}</h3>
          <ul>
            <li v-for="(item, index) in integrationItems" :key="index" v-html="item"></li>
          </ul>

          <OneStopAnimation />
        </div>
      </div>
      <div class="start diagonal">
        <div class="content">
          <h3>{{ $t('home.startTitle') }}</h3>
          <ul>
            <li v-for="(item, index) in startCards" :key="item.title">
              <img :src="startIcons[index]" alt="Start" />
              <h5>{{ item.title }}</h5>
              <p v-html="item.desc"></p>
              <router-link class="button" :to="serviceLinks[index]">
                <span>{{ item.cta }}</span>
                <div class="arrowBox">
                  <span class="arrow">
                    <i /><i /><i />
                  </span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="business diagonal">
        <div class="way content">
          <div class="text">
            <h3>{{ $t('home.accountTitle') }}</h3>
            <p v-html="$t('home.accountBody')"></p>
          </div>

          <MultiEndAnimation />
        </div>
        <div class="api content" ref="api">
          <div class="text">
            <h3>{{ $t('home.apiTitle') }}</h3>
            <p v-html="$t('home.apiBody')"></p>
            <ul>
              <li v-for="(item, index) in apiItems" :key="item.title">
                <img :src="apiIcons[index]" alt="API" />
                <h5>{{ item.title }}</h5>
                <p v-html="item.desc"></p>
              </li>
            </ul>
          </div>
          <ApiAnimation  ref="apiAnimation"/>
        </div>
      </div>
      <div class="carousel diagonal">
        <div class="content">
          <h3>{{ $t('home.testimonialTitle') }}</h3>
          <p v-html="$t('home.testimonialSubtitle')"></p>
          <div class="banner">
            <div class="frame">
              <ul :style="bannerTrackStyle">
                <li v-for="(item ,index) in testimonials" :key="index">
                  <img src="@/assets/images/Home/banner1.png">
                  <div class="textContent">
                    <p>{{ item.quote }}</p>
                    <div>
                      <span v-for="tag in item.tags" :key="tag">{{ tag }}</span>
                    </div>
                    <span>{{ item.author }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <img class="arrow" style="left: -33px" src="@/assets/images/Home/arrow.png" @click="clickPage(-1)">
            <img class="arrow" style="right: -33px; transform: scaleX(-1)" src="@/assets/images/Home/arrow.png" @click="clickPage(1)">
            <div class="mobile-dots">
              <button
                v-for="(item, index) in testimonials"
                :key="`dot-${index}`"
                type="button"
                :class="{ active: currentIndex === index }"
                @click="goToPage(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="credit" ref="credit">
      <div class="globeBox">
        <Globe :renderEnabled="renderGlobe" />
      </div>

      <div class="content">
        <div>
          <h3>{{ $t('home.creditTitle') }}</h3>
          <p v-html="$t('home.creditBody')"></p>
          <ul>
            <li v-for="(item, index) in creditItems" :key="index" v-html="item"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="safe">

      <div class="content">
        <div>
          <h3>{{ $t('home.safeTitle') }}</h3>
          <p v-html="$t('home.safeBody')"></p>
          <router-link class="button" to="/compliance">
            <span>{{ $t('home.safeDetail') }}</span>
            <div class="arrowBox">
              <span class="arrow">
                <i /><i /><i />
              </span>
            </div>
          </router-link>
          <ul>
            <li v-for="(item, index) in safeItems" :key="item.title">
              <img :src="safeIcons[index]" alt="Safe" />
              <h5>{{ item.title }}</h5>
              <p v-html="item.desc"></p>
            </li>
          </ul>
        </div>
        <img src="@/assets/images/Home/aml.png" alt="AML" />
      </div>

    </div>
  </main>
</template>

<script>
import ClientAnimation from '@/components/ClientAnimation'
import OneStopAnimation from '@/components/OneStopAnimation'
import MultiEndAnimation from '@/components/MultiEndAnimation'
import GradientAnimation from '@/components/GradientAnimation'
import ApiAnimation from '@/components/ApiAnimation'
import Globe from '@/components/Globe'

export default {
  name: 'Home',
  components: {
    ClientAnimation,
    OneStopAnimation,
    MultiEndAnimation,
    GradientAnimation,
    ApiAnimation,
    Globe
  },
  data() {
    return {
      height: window.innerHeight,
      startIcons: [
        require('@/assets/images/Home/start-1.png'),
        require('@/assets/images/Home/start-2.png'),
        require('@/assets/images/Home/start-3.png'),
        require('@/assets/images/Home/start-4.png'),
      ],
      apiIcons: [
        require('@/assets/images/Home/api-1.png'),
        require('@/assets/images/Home/api-2.png'),
      ],
      safeIcons: [
        require('@/assets/images/Home/safe-1.png'),
        require('@/assets/images/Home/safe-2.png'),
        require('@/assets/images/Home/safe-3.png'),
      ],
      serviceLinks: ['/services/acquiring', '/services/collection', '/services/exchange', '/services/payment'],
      currentIndex: 0,
      serviceGranim: undefined,
      api_offsetTop: 3000,
      credit_offsetTop: 3000,
      renderGlobe: false, //是否展示地球球体
    };
  },
  mounted() {
    if (window.innerWidth < 1000) this.height = 0;
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1000) this.height = window.innerHeight;
      //qpi距离网页顶部距离
      this.api_offsetTop = this.$refs.api.getBoundingClientRect().top;
      //旋转地球距离网页顶部距离
      this.credit_offsetTop = this.$refs.credit.getBoundingClientRect().top;
    });
    //监听页面是否隐藏 隐藏则取消自动轮播
    document.addEventListener("visibilitychange",this.isShowPage);
    this.createInterval();

    //qpi距离网页顶部距离
    this.api_offsetTop = this.$refs.api.getBoundingClientRect().top;
    //旋转地球距离网页顶部距离
    this.credit_offsetTop = this.$refs.credit.getBoundingClientRect().top;
    window.addEventListener("scroll",this.handleScroll);
  },
  methods: {
    clickPage(add) {
      if(this.currentIndex == 0 && add < 0) return;

      let index = this.currentIndex + add >= this.caseList.length ? 0 : this.currentIndex + add;
      this.closeInterval();
      this.currentIndex = index;
      this.createInterval();
    },
    goToPage(index) {
      this.closeInterval();
      this.currentIndex = index;
      this.createInterval();
    },
    isShowPage() {
      if (document.visibilityState == "visible")
        this.createInterval();

      if (document.visibilityState == "hidden")
        this.closeInterval();
    },
    createInterval() {
      this.closeInterval();
      this.caseInterval = setInterval(() => {
        this.currentIndex += 1;
        if(this.currentIndex >= this.caseList.length)
        {
          this.currentIndex = 0;
        }
      },5000);
    },
    closeInterval() {
      clearInterval(this.caseInterval);
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(' -----------apiAni.isPlaying , this.api_offsetTop = ' , apiAni.isPlaying , this.api_offsetTop);
      let apiAni= this.$refs.apiAnimation;
      if( scrollTop >= this.api_offsetTop){
        apiAni.play();
      }
      //是否显示旋转地球
      if(scrollTop >= this.credit_offsetTop - 700 && scrollTop <= this.credit_offsetTop + 1000) {
        this.renderGlobe = true;
      } else {
        this.renderGlobe = false;
      }
    }
  },
  computed: {
    bannerTrackStyle() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return `transform: translateX(-${this.currentIndex * 100}%);`;
      }
      return `left: ${-1181 * this.currentIndex}px;`;
    },
    isEnglishLocale() {
      return this.$i18n.locale === 'en-US';
    },
    integrationItems() {
      return this.$t('home.integrationItems');
    },
    startCards() {
      return this.$t('home.startCards');
    },
    apiItems() {
      return this.$t('home.apiItems');
    },
    testimonials() {
      return this.$t('home.testimonials');
    },
    creditItems() {
      return this.$t('home.creditItems');
    },
    safeItems() {
      return this.$t('home.safeItems');
    },
    caseList() {
      return this.testimonials;
    },
  },
  destroyed() {
    this.closeInterval();
    document.removeEventListener('visibilitychange' , this.isShowPage);
    window.removeEventListener("scroll",this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.bodyFont(@bodyFontSize: 18px, @bodyLineHeight: 1.555555556, @fontWeightNormal: 300) {
  font: @fontWeightNormal @bodyFontSize/@bodyLineHeight "sohne-var","Helvetica Neue","Arial",sans-serif;
}
p{
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.button{
  height: auto;
  padding: 3px 0 6px;
  .bodyFont(15px, 1.6, 425);
}

.service {
  position: relative;

  .content {
    display: flex;
    height: 823px;
    padding-bottom: 40px;

    & > div:first-child {
      width: 540px;
      margin-top: 184px;

      & > h1 {
        max-width: 540px;
        margin-bottom: 20px;
        color: white;
        font-size: clamp(40px, 4.4vw, 60px);
        font-weight: 400;
        line-height: 1.16;
      }

      & > h1.is-en {
        max-width: 720px;
        font-size: clamp(34px, 3.8vw, 52px);
        line-height: 1.1;
        text-wrap: balance;
      }

      & > h2 {
        margin-bottom: 30px;
        color: white;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
      }

      .action {
        display: flex;

        .button {
          width: 122px;
          margin-right: 20px;
          background: #0070FF;

          &:last-child {
            width: auto;
            background: none;
          }

          &:hover {
            background: #0A2540;

            &:last-child {
              color: #BEBEBE;
              background: none;

              .arrow > i {
                background: #BEBEBE;
              }
            }
          }
        }
      }
    }

    & > div:last-child {
      position: absolute;
      top: 172px;
      right: -261px;
    }
  }
}

.integration {
  margin: -60px 0;
  padding: 150px 0 0;

  &:before {
    background-color: white;
  }

  .content {

    & > h3 {
      margin-bottom: 10px;
      color: #0a2540;
      font-size: 36px;
      font-weight: 400;
      line-height: 54px;
    }

    & > ul {
      display: flex;

      & > li {
        position: relative;
        width: 50%;
        padding-right: 90px;
        color: #425466;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;

        & > span {
          font-weight: 400;
          color: var(--spanColor1);
        }

        &:before {
          position: absolute;
          top: 9px;
          left: -15px;
          width: 1px;
          height: 19px;
          content: '';
          background: #0070FF;
        }
      }
    }

    .oneStop {
      margin-top: 70px;
    }
  }
}

.start {
  &:before {
    background-color: #F6F9FC;
  }

  .content {
    padding: 180px 0;

    & > h3 {
      margin-bottom: 30px;
      color: #082440;
      font-size: 36px;
      font-weight: 400;
      line-height: 54px;
    }

    & > ul {
      display: flex;

      & > li {
        width: 25%;
        padding-right: 55px;

        & > img {
          width: 40px;
          margin-bottom: 20px;
        }

        & > h5 {
          position: relative;
          margin-bottom: 10px;
          color: #082440;
          font-size: 16px;
          line-height: 24px;
          .bodyFont(15px, 1.6, 425);

          &:before {
            position: absolute;
            top: 4px;
            left: -15px;
            width: 1px;
            height: 15px;
            content: '';
            background: #0070FF;
          }
        }

        & > p {
          min-height: 150px;
          color: #092641;
          font-weight: 200;
          line-height: 24px;
          .bodyFont(15px, 1.6);
          & > span {
            color: var(--spanColor1);
          }
        }

        .button {
          width: auto;
          padding-left: 20px;
          padding-right: 20px;
          white-space: nowrap;
          background: #0070FF;
          .bodyFont(15px, 1.6, 425);
          &:hover {
            background: #0A2540;
          }
        }
      }
    }
  }
}

.business {

  &:before {
    width: 130%;
    right: -15%;
    background: linear-gradient(45deg, #7741B0 0%, #696EBC 50%, #E33E6B 100%);
  }

  .way {
    display: flex;
    justify-content: space-between;
    padding: 120px 0;

    .text {
      width: 380px;

      & > h3 {
        margin-bottom: 10px;
        color: white;
        font-size: 36px;
        font-weight: 400;
        line-height: 54px;
      }

      & > p {
        color: #adbdcc;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
      }
    }

    & > div:nth-child(2) {
      margin-top: -130px;
      margin-right: -45px;
    }
  }

  .api {
    padding: 178px 0 230px;
    display: flex;
    justify-content: space-between;

    .text {
      width: 520px;

      & > h3 {
        margin-bottom: 10px;
        color: white;
        font-size: 36px;
        font-weight: 400;
        line-height: 54px;
      }

      & > p {
        margin-bottom: 80px;
        color: #adbdcc;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
      }

      & > ul {
        display: flex;

        & > li {
          width: 50%;
          padding-right: 55px;

          & > img {
            width: 40px;
            margin-bottom: 20px;
          }

          & > h5 {
            position: relative;
            margin-bottom: 10px;
            color: white;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;

            &:before {
              position: absolute;
              top: 4px;
              left: -15px;
              width: 1px;
              height: 15px;
              content: '';
              background: #0070FF;
            }
          }

          & > p {
            color: #adbdcc;
            font-weight: 200;
            .bodyFont(15px, 1.6);
          }
        }
      }
    }

    & > div:last-child {
      margin-top: 170px;
    }
  }
}

.carousel {
  .content {
    padding: 120px 0;

    & > h3 {
      margin-bottom: 10px;
      color: #040404;
      font-size: 40px;
      font-weight: 400;
      line-height: 59px;
      text-align: center;
    }

    & > p {
      margin-bottom: 60px;
      color: #040404;
      font-size: 20px;
      font-weight: 200;
      line-height: 36px;
      text-align: center;
      .bodyFont();
      & > span {
        color: var(--spanColor1);
      }
    }

    .banner {
      position: relative;
      .arrow {
        cursor: pointer;
        position: absolute;
        width: 64px;
        top: 185px;
      }

      .frame {
        position: relative;
        overflow: hidden;
        height: 415px;
        box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
        border-radius: 16px;
        & > ul {
          position: absolute;
          display: flex;
          left: 0;
          & > li {
            position: relative;
            & > img {
              height: 415px;
            }
            .textContent {
              top: 105px;
              left: 68px;
              position: absolute;
              & > p {
                width: 434px;
                font-size: 30px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 38px;
                margin-bottom: 18px;
              }
              & > div {
                margin-bottom: 46px;
               & > span {
                 background: #FFFFFF;
                 border-radius: 13px;
                 padding: 6px 14px;
                 font-size: 12px;
                 font-weight: 400;
                 color: #082440;
                 margin-right: 10px;
                 &:last-child{
                   background: #E68E4F;
                   color: #FFFFFF;
                 }
               }
              }

              & > span {
                font-size: 16px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 38px;
              }
            }
          }
          transition: all 0.3s;
        }
      }
    }
  }

}

.credit {
  position: relative;

  .globeBox {
    position: absolute;
    top: 0;
    right: -5%;
    width: 120%;
    height: 100%;
    content: '';
    transform: rotate(4.5deg);
    background: #0A2440;
    overflow: hidden;
  }
  .globeViz {
    position: absolute;
    top: -10%;
    right: -47%;
    cursor: grab;
    transform: rotate(-4.5deg);
  }
  .content {
    padding: 200px 0 350px;
    pointer-events: none;
    & > div {
      display: inline-block;
      pointer-events: auto;
      & > h3 {
        margin-bottom: 30px;
        color: white;
        font-size: 40px;
        font-weight: 400;
        line-height : 59px;
      }

      & > p {
        margin-bottom: 50px;
        width: 620px;
        color: #adbdcc;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
        & > span {
          color: var(--spanColor2);
        }
      }

      & > ul {

        & > li {
          margin-bottom: 12px;
          color: #adbdcc;
          font-size: 20px;
          font-weight: 200;
          line-height: 29px;
          .bodyFont();

          & > span {
            font-weight: 400;
          }

          &:last-child {
            margin-bottom: 0;
          }

          &:before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            margin: 0 15px 0 10px;
            background: #0BEA82;
            border: 3px solid #2D6552;
            border-radius: 100%;
          }
        }
      }
    }
  }
}

.safe {
  position: relative;
  margin-top: -100px;
  background: white;
  z-index: 2;

  .content {
    display: flex;
    justify-content: space-between;
    padding: 120px 0 50px;

    & > div {

      & > h3 {
        margin-bottom: 10px;
        color: #082440;
        font-size: 36px;
        font-weight: 400;
        line-height: 54px;
      }

      & > p {
        width: 650px;
        margin-bottom: 30px;
        color: #092641;
        font-size: 20px;
        font-weight: 200;
        line-height: 36px;
        .bodyFont();
        & > span {
          color: var(--spanColor1);
        }
      }

      .button {
        width: 122px;
        margin-bottom: 40px;
        background: #0070FF;
        &:hover {
          background: #0A2540;
        }
      }

      & > ul {
        display: flex;

        & > li {
          width: 240px;
          margin-right: 55px;

          &:last-child {
            margin-right: 0;
          }

          & > img {
            width: 40px;
            margin-bottom: 20px;
          }

          & > h5 {
            position: relative;
            margin-bottom: 10px;
            color: #082440;
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;

            &:before {
              position: absolute;
              top: 4px;
              left: -15px;
              width: 1px;
              height: 15px;
              content: '';
              background: #0070FF;
            }
          }

          & > p {
            color: #092641;
            font-size: 16px;
            font-weight: 200;
            line-height: 24px;
            & > span {
              color: var(--spanColor1);
            }
          }
        }
      }
    }

    & > img {
      position: relative;
      bottom: -124px;
      height: 456px;
      margin-right: -48px;
    }
  }
}

@media screen and (max-width: 1000px) {
  .service .content {
    flex-direction: column;
    height: auto;
    padding: 110px 0 40px;

    & > div:first-child {
      width: 100%;
      margin-top: 0;

      & > h1,
      & > h1.is-en,
      & > h2 {
        max-width: none;
        text-align: center;
      }

      & > h1,
      & > h1.is-en {
        font-size: 34px;
        line-height: 1.18;
      }

      & > h2 {
        font-size: 18px;
        line-height: 30px;
      }

      .action {
        justify-content: center;
      }
    }

    & > div:last-child {
      position: relative;
      top: 0;
      right: 0;
      width: 100%;
      margin-top: 24px;
      display: flex;
      justify-content: center;
      transform: scale(0.78);
      transform-origin: top center;
    }
  }

  .integration,
  .start .content,
  .business .way,
  .business .api,
  .carousel .content,
  .credit .content,
  .safe .content {
    padding-left: 20px;
    padding-right: 20px;
  }

  .integration .content > ul,
  .start .content > ul,
  .business .api .text > ul,
  .safe .content > div > ul,
  .business .way,
  .business .api,
  .safe .content {
    flex-direction: column;
  }

  .integration .content > ul > li,
  .start .content > ul > li,
  .business .api .text > ul > li,
  .safe .content > div > ul > li {
    width: 100%;
    padding-right: 0;
    margin-right: 0;
    margin-bottom: 24px;
  }

  .business .way .text,
  .business .api .text {
    width: auto;
    max-width: 100%;
    min-width: 0;
  }

  .business .way > div:nth-child(2),
  .business .api > div:last-child,
  .safe .content > img {
    margin: 24px 0 0;
    align-self: center;
  }

  .business .way > div:nth-child(2),
  .business .api > div:last-child {
    transform: scale(0.82);
    transform-origin: top center;
  }

  .carousel .content .banner .arrow,
  /*.service {*/
  /*  .bg1 {*/
  /*    width: 189px;*/
  /*  }*/

  /*  .bg2 {*/
  /*    width: 165px;*/
  /*  }*/

  /*  & > ul {*/
  /*    bottom: 10px;*/

  /*    & > li {*/
  /*      margin: 0 5px;*/
  /*      font-size: 12px;*/
  /*    }*/
  /*  }*/

  /*  .content {*/
  /*    flex-direction: column;*/
  /*    justify-content: center;*/
  /*    min-height: auto;*/
  /*    padding: 50px 20px 70px;*/

  /*    & > div:first-child {*/
  /*      width: auto;*/
  /*      display: flex;*/
  /*      flex-direction: column;*/
  /*      align-items: center;*/

  /*      & > h1 {*/
  /*        font-size: 32px;*/
  /*        margin-bottom: 20px;*/
  /*        text-align: center;*/
  /*      }*/

  /*      & > p {*/
  /*        margin-bottom: 32px;*/
  /*        font-size: 18px;*/
  /*        line-height: 28px;*/
  /*        text-align: center;*/
  /*      }*/

  /*      & > a {*/
  /*        position: relative;*/
  /*        width: 200px;*/
  /*        height: 40px;*/
  /*        font-size: 14px;*/
  /*        line-height: 40px;*/
  /*        border-radius: 20px;*/
  /*        z-index: 1;*/
  /*      }*/
  /*    }*/

  /*    & > div:last-child {*/
  /*      margin: -220px 0;*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.choice {*/
  /*  padding: 32px 20px;*/

  /*  & > h1 {*/
  /*    margin-bottom: 32px;*/
  /*  }*/

  /*  & > ul {*/
  /*    height: auto;*/
  /*    flex-direction: column;*/

  /*    & > li {*/
  /*      position: relative;*/
  /*      display: flex;*/
  /*      flex-direction: column;*/
  /*      justify-content: center;*/
  /*      width: calc(100% - 30px);*/
  /*      height: 125px;*/
  /*      padding: 0 0 0 60px;*/
  /*      border-right: none;*/
  /*      border-bottom: 1px solid #E5E5E5;*/

  /*      &:last-child {*/
  /*        border-bottom: none;*/
  /*      }*/

  /*      & > i {*/
  /*        position: absolute;*/
  /*        top: 20px;*/
  /*        left: 0;*/
  /*      }*/

  /*      & > h3 {*/
  /*        font-size: 18px;*/
  /*        margin-bottom: 5px;*/
  /*      }*/

  /*      & > span {*/
  /*        line-height: 24px;*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.account {*/
  /*  .content {*/
  /*    padding: 32px 20px;*/

  /*    .desc {*/
  /*      margin-bottom: 0;*/
  /*      padding: 20px 15px;*/
  /*      flex-direction: column;*/
  /*      align-items: flex-start;*/
  /*      justify-content: center;*/

  /*      & > div {*/
  /*        width: auto;*/

  /*        & > h1 {*/
  /*          margin-bottom: 10px;*/
  /*          font-size: 28px;*/
  /*        }*/

  /*        & > span {*/
  /*          display: inline-block;*/
  /*          margin-bottom: 20px;*/
  /*          font-size: 18px;*/
  /*          line-height: 28px;*/
  /*        }*/
  /*      }*/

  /*      & > a {*/
  /*        height: 32px;*/
  /*        font-size: 14px;*/
  /*        line-height: 32px;*/
  /*        border-radius: 16px;*/
  /*      }*/
  /*    }*/

  /*    .list {*/
  /*      flex-direction: column;*/

  /*      & > img {*/
  /*        width: 100%;*/
  /*        margin-left: 0;*/
  /*        margin-bottom: -15px;*/
  /*      }*/

  /*      & > ul {*/
  /*        flex-direction: column;*/
  /*        margin-bottom: 0;*/

  /*        & > li {*/
  /*          width: 100%;*/
  /*          margin-left: 0;*/
  /*          margin-bottom: 20px;*/

  /*          & > h3 {*/
  /*            margin-bottom: 8px;*/
  /*            font-size: 18px;*/
  /*          }*/

  /*          & > span {*/
  /*            color: #72747D;*/
  /*            line-height: 24px;*/
  /*          }*/
  /*        }*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.global {*/
  /*  .bg1 {*/
  /*    width: 228px;*/
  /*  }*/

  /*  .bg2 {*/
  /*    width: 200px;*/
  /*  }*/

  /*  .content {*/
  /*    padding: 40px 20px;*/

  /*    & > h1 {*/
  /*      margin-bottom: 36px;*/
  /*    }*/

  /*    .number {*/
  /*      flex-wrap: wrap;*/
  /*      justify-content: space-around;*/
  /*      margin-bottom: 30px;*/

  /*      & > li {*/
  /*        width: 33.33333%;*/
  /*        margin-bottom: 20px;*/
  /*      }*/
  /*    }*/

  /*    .region {*/
  /*      & > li {*/
  /*        width: calc(50% - 8px);*/
  /*        height: 34px;*/
  /*        margin-bottom: 15px;*/
  /*        padding-left: 10px;*/

  /*        & > img {*/
  /*          margin-right: 10px;*/
  /*        }*/

  /*        &:nth-child(n+5):nth-child(-n+10) {*/
  /*          display: none;*/
  /*        }*/

  /*        &:empty {*/
  /*          background: linear-gradient(180deg,#52597B 0%,#3B4368 100%);*/
  /*          box-shadow: none;*/
  /*        }*/
  /*      }*/
  /*    }*/

  /*    & > a {*/
  /*      width: 200px;*/
  /*      height: 40px;*/
  /*      margin: 0 auto 50px;*/
  /*      line-height: 40px;*/
  /*      border-radius: 20px;*/
  /*    }*/

  /*    & > h3 {*/
  /*      width: auto;*/
  /*      font-size: 18px;*/
  /*      line-height: 28px;*/
  /*    }*/
  /*  }*/
  /*}*/

  /*!* 即将推出 *!*/
  /*.coming {*/
  /*  margin-bottom: 10px;*/
  /*}*/

  /*.card {*/
  /*  position: relative;*/

  /*  .bg1 {*/
  /*    width: 230px;*/
  /*  }*/

  /*  .bg2 {*/
  /*    width: 200px;*/
  /*  }*/

  /*  .content {*/
  /*    flex-direction: column;*/
  /*    justify-content: center;*/
  /*    padding: 50px 20px;*/

  /*    & > div {*/
  /*      width: auto;*/

  /*      & > h1 {*/
  /*        margin-bottom: 10px;*/
  /*      }*/

  /*      & > p {*/
  /*        margin-bottom: 26px;*/
  /*        font-size: 18px;*/
  /*      }*/

  /*      & > ul {*/
  /*        display: flex;*/
  /*        justify-content: space-between;*/
  /*        margin-bottom: 24px;*/

  /*        & > li {*/
  /*          width: calc(50% - 18px);*/

  /*          & > h3 {*/
  /*            margin-bottom: 8px;*/
  /*            font-size: 18px;*/
  /*          }*/

  /*          & > span {*/
  /*            font-size: 18px;*/
  /*            line-height: 28px;*/
  /*          }*/
  /*        }*/
  /*      }*/

  /*      & > a {*/
  /*        width: 200px;*/
  /*        height: 40px;*/
  /*        margin-bottom: 26px;*/
  /*        line-height: 40px;*/
  /*        border-radius: 20px;*/
  /*      }*/
  /*    }*/

  /*    & > img {*/
  /*      width: 100%;*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.business {*/
  /*  .content {*/
  /*    flex-direction: column;*/
  /*    justify-content: center;*/
  /*    padding: 40px 20px;*/

  /*    & > img {*/
  /*      width: 100%;*/
  /*      margin-bottom: 32px;*/
  /*    }*/

  /*    & > div {*/
  /*      width: auto;*/

  /*      & > h1 {*/
  /*        margin-bottom: 10px;*/
  /*      }*/

  /*      & > p {*/
  /*        font-size: 18px;*/
  /*        line-height: 28px;*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.risk {*/
  /*  .content {*/
  /*    padding: 40px 20px;*/

  /*    & > h1 {*/
  /*      margin-bottom: 10px;*/
  /*    }*/

  /*    & > p {*/
  /*      margin-bottom: 30px;*/
  /*      font-size: 18px;*/
  /*    }*/

  /*    & > ul {*/
  /*      flex-direction: column;*/
  /*      padding: 20px 15px;*/

  /*      & > li {*/
  /*        width: 100%;*/
  /*        height: auto;*/
  /*        margin-bottom: 16px;*/
  /*        padding: 0;*/
  /*        border-right: none;*/

  /*        &:last-child {*/
  /*          margin-bottom: 0;*/
  /*        }*/

  /*        & > h3 {*/
  /*          margin-bottom: 5px;*/

  /*          & > span {*/
  /*            display: inline;*/
  /*          }*/

  /*          & > br {*/
  /*            display: none;*/
  /*          }*/
  /*        }*/

  /*        & > span {*/
  /*          line-height: 24px;*/
  /*        }*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.partner {*/
  /*  padding: 40px 0;*/
  /*  & > h2 {*/
  /*    margin-bottom: 30px;*/
  /*  }*/
  /*  & > ul {*/
  /*    flex-wrap: wrap;*/
  /*    justify-content: center;*/
  /*    & > li {*/
  /*      width: calc(33% - 8px);*/
  /*      height: 43px;*/
  /*      margin-bottom: 10px;*/
  /*      & > img {*/
  /*        max-width: 98px;*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.case {*/
  /*  background: #3B4368;*/
  /*  .content {*/
  /*    padding: 60px 0;*/
  /*    & > h1 {*/
  /*      color: white;*/
  /*      text-align: center;*/
  /*      margin-bottom: 43px;*/
  /*    }*/

  /*    .showCase {*/
  /*      height: 446px;*/
  /*      & > li {*/
  /*        display: flex;*/
  /*        flex-direction: column;*/
  /*        & > img {*/
  /*          position: static;*/
  /*          height: 261px;*/
  /*        }*/
  /*        & > div {*/
  /*          position: static;*/
  /*          padding: 20px 15px;*/
  /*          width: 290px;*/
  /*          & > p {*/
  /*            &:nth-child(1) {*/
  /*              font-size: 18px;*/
  /*              margin-bottom: 23px;*/
  /*            }*/
  /*          }*/
  /*        }*/
  /*      }*/
  /*    }*/

  /*    .pages {*/
  /*      margin-top: 40px;*/
  /*    }*/
  /*  }*/
  /*}*/

  /*.step {*/
  /*  padding: 40px 20px 50px;*/

  /*  & > h1 {*/
  /*    margin-bottom: 26px;*/
  /*  }*/

  /*  & > ul {*/
  /*    width: auto;*/

  /*    & > li {*/
  /*      height: 96px;*/
  /*      margin-bottom: 15px;*/
  /*      padding: 15px;*/
  /*    }*/
  /*  }*/
  /*}*/

  .carousel .content .banner .frame {
    height: auto;

    & > ul {
      position: static;
      display: block;

      & > li {
        width: 100%;

        &:not(:first-child) {
          display: none;
        }

        & > img {
          width: 100%;
          height: auto;
        }

        .textContent {
          top: auto;
          left: auto;
          position: static;
          padding: 24px 20px 28px;
          background: #0A2440;

          & > p {
            width: auto;
          }
        }
      }
    }
  }

  .credit {
    .globeBox {
      display: none;
    }

    .content {
      padding: 80px 0;

      & > div > p {
        width: auto;
      }
    }
  }

  .safe .content > div > p {
    width: auto;
  }
}

@media screen and (max-width: 768px) {
  .service .content {
    height: auto;
    min-height: auto;
    padding: 100px 16px 28px;
    flex-direction: column;

    & > div:first-child {
      width: 100%;
      margin-top: 0;

      & > h1 {
        max-width: none;
        margin-bottom: 16px;
        font-size: 24px;
        line-height: 1.25;
        text-align: center;
      }

      & > h1.is-en {
        font-size: 24px;
        line-height: 1.25;
      }

      & > h2 {
        margin-bottom: 24px;
        font-size: 15px;
        line-height: 1.75;
        text-align: left;
      }

      .action {
        flex-direction: column;
        align-items: center;
        gap: 12px;

        .button {
          width: 100%;
          max-width: 320px;
          margin: 0;
        }
      }
    }

    & > div:last-child {
      display: none;
    }
  }

  .integration {
    margin: 0;
    padding-top: 72px;

    .content {
      padding-left: 16px;
      padding-right: 16px;

      & > h3 {
        font-size: 28px;
        line-height: 36px;
      }

      & > ul > li {
        width: 100%;
        padding-right: 0;
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  .business {
    .way.content,
    .api.content {
      padding-top: 80px;
      padding-bottom: 0;
      padding-left: 16px;
      padding-right: 16px;
      gap: 24px;
    }

    .way.content > div:last-child,
    .api.content > div:last-child {
      display: none;
    }

    .way .text,
    .api .text {
      width: auto;
      max-width: 100%;
      min-width: 0;
    }

    .text {
      min-width: 0;

      & > h3 {
        font-size: 28px;
        line-height: 36px;
        overflow-wrap: break-word;
      }

      & > p {
        font-size: 16px;
        line-height: 28px;
        overflow-wrap: break-word;
        word-break: break-word;
      }
    }

    .way.content {
      padding-bottom: 16px;
    }

    .api.content {
      padding-top: 64px;
      padding-bottom: 96px;
    }
  }

  .carousel .content {
    padding: 72px 16px 88px;

    & > h3 {
      font-size: 28px;
      line-height: 36px;
      text-align: left;
    }

    & > p {
      margin-bottom: 32px;
      font-size: 16px;
      line-height: 28px;
      text-align: left;
    }

    .banner {
      .frame {
        border-radius: 20px;

        & > ul {
          display: flex;
          position: relative;
          left: auto !important;
          transition: transform 300ms ease;

          & > li {
            flex: 0 0 100%;
            width: 100%;
            display: block !important;

            & > img {
              width: 100%;
              height: auto;
            }

            .textContent {
              padding: 20px 16px 24px;

              & > p {
                font-size: 20px;
                line-height: 30px;
              }

              & > div {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 24px;

                & > span {
                  margin-right: 0;
                }
              }

              & > span {
                line-height: 24px;
              }
            }
          }
        }
      }

      .arrow {
        display: none;
      }

      .mobile-dots {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 18px;

        button {
          width: 8px;
          height: 8px;
          padding: 0;
          border: none;
          border-radius: 999px;
          background: rgba(8, 36, 64, 0.18);
          cursor: pointer;
          transition: all 180ms ease;
        }

        .active {
          width: 22px;
          background: #0070FF;
        }
      }
    }
  }

  .credit .content {
    padding: 96px 16px 120px;
  }

  .safe .content {
    padding-left: 16px;
    padding-right: 16px;

    & > img {
      display: none;
    }
  }

  .start .content,
  .carousel .content {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
